import React from 'react';

function HashIdForm({ hashId, setHashId, handleGetTeamInfo }) {
  return (
    <div>
      <div className="p-4 gap-x-6 gap-y-8">
        <div className="sm:col-span-4 text-white">
          <label htmlFor="hashId" className="block text-sm font-bold leading-6 text-xl  p-2">
            Ingresar el Hash ID del equipo
          </label>
          <div className="p-2 mt-3">
            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 max-w-52">
            
              <input
                id="hashId"
                name="hashId"
                value={hashId}
                size="8"
                onChange={(e) => setHashId(e.target.value)}
                className="block flex-1 border-0 bg-transparent px-2 py-1.5 font-bold placeholder:text-white focus:ring-0 sm:leading-6 text-3xl tracking-wide"
              />
            </div>
          </div>
          <p className="text-sm leading-6 p-2">
            El Hash ID es código alfanumérico único de 8 caracteres y no deberá ser compartido con nadie fuera de tu equipo.
          </p>
        </div>
      </div>
      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          onClick={handleGetTeamInfo}
          className="rounded-md bg-blue-700 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Comenzar
        </button>
      </div>
    </div>
  );
}

export default HashIdForm;
